

const impData = {
  // 用于修改行数据
  state: {
    tmplInfo:[],//模板列表
    contentList: [], // 导入内容
    noMatchTitleList: [], // 未匹配的标题
    matchTitleList: [], // 已匹配的标题
    fileTitleList: [], // 导入excel的表头
    fileName: [], // 导出excel的名称
    errList:[],//导入时错误信息
    successCount: 0, // 导入成功的条数
    errorCount: 0, // 导入失败的条数
    success: '',// 导入状态
    tableNames: '',// 导入的临时表名
    tmplIds: '',// 导入的模板id 可以多个
    empInfoSysList:[],//雇员基本信息
    empBankCardSysList:[],//雇员银行卡信息
    empDeclareTaxSysList:[],//雇员报税信息
    excelInfoList:[],//excel表头及数据
    sheetName:'',//sheet名称
    countTotal:0,//导入总数
    infoCount:0,//提示信息总数
    infoList:[],//提示信息
    tableName:'',//临时表名
    cusId:'',//客户id
    cusName:'',//客户名称
    flag:'false',//标志批量修改雇员点击再次上传跳转到第一步的时候不再提示下载模板
    stepMark:'false',//用于标识点击下一步或者上一步的时候应该是跳转到结果页面还是上传页面
    upFileName:'',//上传的文件名称
    upFileNameIsShow:'false',//上传的文件名称是否显示
    fileId:'',//上传到文件服务上返回的文件id
    tmplId:'',//雇员导入模板只涉及一个
  },
  mutations: {},
};

export default impData;
